import "./style.css";

export default class Breadcrumb {
  static selector = ".breadcrumb";
  constructor(block) {
    const domain = window.location.host;

    // console.log(domain, document.referrer, document.referrer.match(domain));

    if (!document.referrer.match(domain)) {
      block.style.display = "none";
    }
  }
}
